// extracted by mini-css-extract-plugin
module.exports = {"container":"_11U86","title":"_1ivDn","postsList":"_26Nnw","postListItem":"_29XG2"};